export enum ClaimStatus {
  OPEN = 'OPEN',
  SENT = 'SENT',
  AWAITING_INFO = 'AWAITING_INFO',
  COMPLETED = 'COMPLETED',
}

export const getClaimStatusLabel = (status: ClaimStatus): string => {
  switch (status) {
    case ClaimStatus.OPEN:
      return $localize`En cours de transmission`;
    case ClaimStatus.SENT:
      return $localize`Transmis`;
    case ClaimStatus.AWAITING_INFO:
      return $localize`En attente de documentation`;
    case ClaimStatus.COMPLETED:
      return $localize`Terminé`;
    default:
      return '';
  }
};

export const getClaimStatusBadge = (status: ClaimStatus): string => {
  switch (status) {
    case ClaimStatus.OPEN:
      return 'zinc';
    case ClaimStatus.SENT:
      return 'success';
    case ClaimStatus.AWAITING_INFO:
      return 'blue';
    case ClaimStatus.COMPLETED:
      return 'success';
    default:
      return '';
  }
};

export const getClaimStatusChartLabel = (status: ClaimStatus): string => {
  switch (status) {
    case ClaimStatus.OPEN:
      return $localize`Déclaré`;
    case ClaimStatus.SENT:
      return $localize`Transmis`;
    case ClaimStatus.AWAITING_INFO:
      return $localize`En attente d'information`;
    case ClaimStatus.COMPLETED:
      return $localize`Traité`;
    default:
      return '';
  }
};
